export default function PHP_syslog() {
  return (
    <div>
      <h1>PHP_syslog</h1>
    </div>
  );
}
